<template>
  <v-footer absolute class="transparent">
    <v-col class="text-center pa-1" cols="12" style="position:relative">
      <v-avatar size="50" tile>
        <v-img src="/img/logo.png"></v-img>
      </v-avatar>
      <div class="white--text mt-1 font-weight-light">Powered by Aya Cup</div>
      <v-switch
        hide-details
        v-model="lightMode"
        color="white"
        :label="lightMode ? '🌞' : '🌛'"
        style="position:absolute;bottom:6px;"
      ></v-switch>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  computed: {
    color() {
      if (this.lightMode) {
        return "#62A0F0";
      } else {
        return "#021F23";
      }
    },
    lightMode: {
      get() {
        return this.$store.state.lightMode;
      },
      set(val) {
        return this.$store.commit("setLightMode", val);
      }
    }
  }
};
</script>


